// extracted by mini-css-extract-plugin
export default {"Navbar":"freemium-navbar_Navbar__qopP+"};